import { useMemo } from 'react';

import {
  getDatosPago as axiosGetDatosPago,
  getMetodosPago as axiosGetMetodosPago,
  postDatosPago as axiosPostDatosPago,
} from '../../axios/Pago/index';
import { DATOS_PAGO, GET_PAYMENT } from '../../axios/Utils/constants';
import { DatosPago, MedioPagoReq, MetodoPago } from '../../types/Pago/types';
import { useCreateEntity, useFetchEntity } from '../Utils/useEntity';

export const usePostDatosPago = () => {
  const { create, isLoading, error } =
    useCreateEntity<MedioPagoReq, DatosPago | undefined>(async (body) => {
      const res = await axiosPostDatosPago(body);
      return res.data;
    });

  return { postDatosPago: create, isLoading, error };
};

export const useGetDatosPago = (enabled: boolean) => {
  const { data, error, isValidating, mutate } = useFetchEntity<DatosPago[]>(
    enabled ? DATOS_PAGO : null, // ✅ evita el fetch en edición de mascota
    async () => {
      const res = await axiosGetDatosPago();
      return res.data;
    },
  );

  return { datosPago: data, isValidating, error, mutate };
};

export const useGetMetodosPago = (enabled: boolean) => {
  const { data, error, isValidating, mutate } = useFetchEntity<MetodoPago[]>(
    enabled ? GET_PAYMENT : null, // ✅ evita el fetch en edición de mascota
    async () => {
      const res = await axiosGetMetodosPago();
      return res.data;
    },
  );

  const metodosPago = useMemo(() => {
    if (!data) return { tarjeta: [], cbu: [] };

    return {
      tarjeta: data.filter((p) => p.verifica === 'luhn'),
      cbu: data.filter((p) => p.verifica === 'cbu'),
    };
  }, [data]);

  return { metodosPago, isValidating, error, mutate };
};
